import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { environment } from './environments/environment';

export function initRum() {
  if (process.env.NODE_ENV !== 'production' || !environment.rumApplicationId) {
    return;
  }

  try {
    const config: AwsRumConfig = {
      endpoint: `https://dataplane.rum.${environment.rumRegion}.amazonaws.com`,
      allowCookies: true,
      identityPoolId: environment.rumIdentityPoolId,
      sessionSampleRate: 0.01,
      enableXRay: true,
      signing: true, // If you have a public resource policy and wish to send unsigned requests please set this to false
      telemetries: [
        'performance',
        [
          'errors',
          {
            // Ignore JS runtime errors and unhandled rejections from these domains
            ignore: (event: any) => {
              const message = String(event?.message || event?.reason || '');
              const sourceUrl = String(event?.filename || event?.target?.src || event?.target?.href || '');
              const ignoreRegex = /api\.mapbox\.com|sockjs-mt1\.pusher\.com/i;

              // Returns true (ignores the error) if the domain is in the message or source file
              return ignoreRegex.test(message) || ignoreRegex.test(sourceUrl);
            },
          },
        ],
        [
          'http',
          {
            // Ignore network requests and HTTP errors to these domains
            urlsToExclude: [/api\.mapbox\.com/i, /sockjs-mt1\.pusher\.com/i],
          },
        ],
      ],
    };

    new AwsRum(environment.rumApplicationId, environment.rumVersion ?? 'unknown', environment.rumRegion, config);
  } catch {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}
